import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import PACSLogFilter from '@components/molecules/Log/PACSLogFilter';
import { Pagination, Worklist } from '@components/organisms';
import { PACSLogBody, StyledLearnMore, StyledMiddleLine, StyledTabs, StyledTotal } from './style';

type TabType = 'inbound' | 'outbound';

const PACSLogPage = () => {
  const [tab, setTab] = useState<TabType>('inbound');
  const [valueState, setValueState] = useState({
    searchKey: '',
    searchKeyword: '',
    dateRange: { startDate: '', endDate: '' },
  });

  const tabClickHandler = (tab: TabType) => {
    setTab(tab);
  };

  return (
    <>
      <label>PACS log</label>
      <PACSLogBody data-page-type="table-only">
        <StyledTabs tab={tab}>
          <li className={tab === 'inbound' ? 'active' : ''} onClick={() => tabClickHandler('inbound')}>
            Inbound
          </li>
          <li className={tab === 'outbound' ? 'active' : ''} onClick={() => tabClickHandler('outbound')}>
            Outbound
          </li>
        </StyledTabs>

        <PACSLogFilter searchConditions={valueState} />

        <StyledMiddleLine>
          <StyledTotal>
            <span>Total</span>
            <span>103</span>
          </StyledTotal>
          <div>
            <Link to={`/sw/pacs_cloud`}>S/W &gt; PACS</Link>
          </div>
        </StyledMiddleLine>

        <Worklist
          headers={[
            { label: 'Id', data_label: 'id' },
            { label: 'Patient Id', data_label: 'patientId' },
            { label: 'Patient Name', data_label: 'name' },
            { label: 'Study UID', data_label: 'studyUid' },
            { label: 'Series UID', data_label: 'seriesUid' },
            { label: 'Modality', data_label: 'modality' },
            { label: 'Series Description', data_label: 'seriesDescription' },
            { label: 'AE Title', data_label: 'aeTitle' },
            { label: 'Date', data_label: 'date' },
            { label: 'Error', data_label: 'error' },
          ]}
          data={{
            dataArray: [
              {
                id: 1,
                patientId: 'qweqwe',
                name: 'qweqwe',
                studyUid: 'qweqwe',
                seriesUid: 'qweqwe',
                modality: 'MR',
                seriesDescription: 'Heuron',
                aeTitle: 'heuron-ad',
                date: '2023-07-04 12:50:49',
                error: 'qweqwe',
              },
              {
                id: 2,
                patientId: 'qweqwe',
                name: 'qweqwe',
                studyUid: 'qweqwe',
                seriesUid: 'qweqwe',
                modality: 'MR',
                seriesDescription: 'Heuron',
                aeTitle: 'heuron-ad',
                date: '2023-07-04 12:50:49',
                error: undefined,
              },
              {
                id: 3,
                patientId: 'qweqwe',
                name: 'qweqwe',
                studyUid: 'qweqwe',
                seriesUid: 'qweqwe',
                modality: 'MR',
                seriesDescription: 'Heuron',
                aeTitle: 'heuron-ad',
                date: '2023-07-04 12:50:49',
                error: 'qweqwe',
              },
            ],
          }}
          customColumn={{
            patientId: (row) => {
              const value =
                row.patientId.slice(0, 2) +
                Array(row.patientId.length - 2)
                  .fill(undefined)
                  .map(() => '*')
                  .join('');

              return <>{value}</>;
            },
            name: (row) => {
              const value =
                row.name.slice(0, 2) +
                Array(row.name.length - 2)
                  .fill(undefined)
                  .map(() => '*')
                  .join('');

              return <>{value}</>;
            },
            error: (row) => {
              if (!row.error) {
                return <>-</>;
              }

              return <StyledLearnMore>Learn more</StyledLearnMore>;
            },
          }}
        />

        <Pagination
          conditions={{}}
          setConditions={() => {
            //
          }}
        />
      </PACSLogBody>
    </>
  );
};

export default PACSLogPage;
